// extracted by mini-css-extract-plugin
export default {"logoWrap":"index_logoWrap__pVNV3","logo":"index_logo__IAk8a","ctaWrapper":"index_ctaWrapper__3GbaP","icon":"index_icon__iViOO","linkText":"index_linkText__2QYpq"};